module.exports = __webpack_public_path__ + "img/CZ28198131.39c355e7.png";